import { render, staticRenderFns } from "./StockRotation.vue?vue&type=template&id=5710ef8a&scoped=true&"
import script from "./StockRotation.vue?vue&type=script&lang=js&"
export * from "./StockRotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5710ef8a",
  null
  
)

export default component.exports